import React from 'react'
import './SimplifiedHeader.less'

type SimplifiedHeaderProps = {
  logoUrl?: string
  cdnHost?: string
}

const DEFAULT_CDN_HOST = 'www.paypalobjects.com'
const LOGO_PATH = '/marketing/web/logos/paypal-mark-color_new.svg'

const SimplifiedHeader: React.FC<SimplifiedHeaderProps> = ({
  logoUrl,
  cdnHost,
}) => {
  const defaultLogoUrl = `https://${cdnHost || DEFAULT_CDN_HOST}${LOGO_PATH}`

  return (
    <header className="simplified-header" data-testid="simplified-header">
      <div className="simplified-header__container">
        <a
          href="/"
          className="simplified-header__logo"
          data-testid="simplified-header-logo"
        >
          <img
            src={logoUrl || defaultLogoUrl}
            alt="PayPal Logo"
            className="simplified-header__logo-image"
          />
        </a>
      </div>
    </header>
  )
}

export default SimplifiedHeader
